import React from "react";
import {Link, Redirect, Route, Switch, useLocation} from "react-router-dom";
import {Container, Row} from "reactstrap";
import routes from "../routes";
import aceLogo from "../assets/img/brand/ace-logo.png";
import progressLogo from "../assets/img/brand/logo-progress.png";
import leftLogo from "../assets/img/backgrounds/auth-character-left.png";
import rightLogo from "../assets/img/backgrounds/auth-character-right.png";
import activ8Logo from "../assets/img/icons/user/activ8Logo.png";

const Auth = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    console.log(props.metadata);
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (_routes) => {
    return _routes.map((route, key) => {
      if (route.layout === "/auth") {
        return (
            <Route
                key={key}
                path={route.layout + route.path}
                name={route.name}
                render={renderProps => <route.component {...renderProps} metadata={props.metadata}/>}
            />
        );
      } else {
        return null;
      }
    });
  };

  return (
      <>
        <div className="d-flex flex-column justify-content-between" style={{height: "100vh"}}>
          <div className="header">
            <div style={{backgroundColor: "#04A1FE"}}
                 className={`d-flex py-4 justify-content-center`}>
              <Link to="/">
                <img alt="..." src={props.metadata.environment === "progress" ? progressLogo : aceLogo}/>
              </Link>
            </div>
          </div>
          <div className="main-content py-5" ref={mainContent}>
            {/*<div className="d-lg-none text-center py-5 mb-3" style={{backgroundColor: "#04A1FE"}}>*/}
            {/*  <img src={authLogo}/>*/}
            {/*</div>*/}
            {/* Page content */}
            {/*mt--8*/}
            <div className="d-flex">
              {props.location.pathname.includes("login") &&
                  <div className="d-none d-lg-block">
                    <img src={leftLogo}/>
                  </div>
              }
              <Container className="">
                <Row className="justify-content-center">
                  <Switch>
                    {getRoutes(routes.common)}
                    <Redirect from="*" to="/auth/login"/>
                  </Switch>
                </Row>
              </Container>
              {props.location.pathname.includes("login") &&
                  <div className="d-none d-lg-block">
                    <img src={rightLogo}/>
                  </div>
              }
            </div>
          </div>
          <div className="assessment-footer py-3">
            <Container fluid
                       className="d-flex align-items-center justify-content-between flex-wrap assessment-main-container">
              <img src={activ8Logo}/>
              <span className="text-sm footer-text">
            © {new Date().getFullYear()}{" "}
                <a
                    className="ml-1 text-dark"
                    href="https://activ8games.com" target="_blank"
                >
              All rights reserved Activ8Games
            </a>
          </span>
            </Container>
          </div>
        </div>
      </>
  );
};

export default Auth;
